import './scss/index.scss';
import { dcFactory } from 'dc';
import ModalComponent from './js/modal.component';

dcFactory.register(ModalComponent);
